(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function getScrollKey() {
    return 'scroll:' + location.pathname + location.search;
  }

  var isCollectionPage = location.pathname.indexOf('/collections/') === 0;

  // The grid-ready wait below gives up after this long regardless of whether
  // the event ever arrives, so the scroll lock's own backstop (further down)
  // is set slightly beyond it — it should never be the one that fires under
  // normal conditions, only if something breaks the primary restore path.
  var RESTORE_TIMEOUT_MS = 5000;
  var SCROLL_LOCK_SAFETY_MS = RESTORE_TIMEOUT_MS + 1000;

  // Block user-driven scrolling (wheel/touch/keys) while the PLP grid is
  // hidden and awaiting restoration, so the user can't scroll away from the
  // saved position before it's applied. overflow:hidden alone doesn't
  // reliably stop this on every browser (e.g. iOS rubber-banding). Scoped to
  // collection pages only.
  var SCROLL_KEYS = [' ', 'Spacebar', 'PageUp', 'PageDown', 'End', 'Home', 'ArrowUp', 'ArrowDown'];
  var lockSafetyTimer = null;
  function preventScroll(e) {
    e.preventDefault();
  }
  function preventScrollKeys(e) {
    if (SCROLL_KEYS.indexOf(e.key) !== -1) {
      e.preventDefault();
    }
  }
  function lockScroll() {
    window.addEventListener('wheel', preventScroll, { passive: false });
    window.addEventListener('touchmove', preventScroll, { passive: false });
    window.addEventListener('keydown', preventScrollKeys);
    // Hard safety net: the lock must never outlive the restore, even if some
    // unrelated failure stops restoreScrollPosition() from ever running.
    lockSafetyTimer = setTimeout(function () {
      document.documentElement.classList.remove('restoring-scroll');
      document.documentElement.classList.remove('restoring-scroll-plp');
      unlockScroll();
    }, SCROLL_LOCK_SAFETY_MS);
  }
  function unlockScroll() {
    window.removeEventListener('wheel', preventScroll, { passive: false });
    window.removeEventListener('touchmove', preventScroll, { passive: false });
    window.removeEventListener('keydown', preventScrollKeys);
    if (lockSafetyTimer !== null) {
      clearTimeout(lockSafetyTimer);
      lockSafetyTimer = null;
    }
  }

  // Check if we should hide content
  var navEntries = performance.getEntriesByType('navigation');
  var navType = navEntries.length ? navEntries[0].type : null;
  var savedPosition = sessionStorage.getItem(getScrollKey());

  if (navType === 'back_forward' && savedPosition !== null) {
    document.documentElement.classList.add('restoring-scroll');
    if (isCollectionPage) {
      document.documentElement.classList.add('restoring-scroll-plp');
      lockScroll();
    }
  }

  // Save scroll
  var scrollTimeout;
  window.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      sessionStorage.setItem(getScrollKey(), window.pageYOffset);
    }, 100);
  });

  // Restore scroll
  function restoreScrollPosition() {
    var savedPosition = sessionStorage.getItem(getScrollKey());
    var finish = function () {
      document.documentElement.classList.remove('restoring-scroll');
      document.documentElement.classList.remove('restoring-scroll-plp');
      unlockScroll();
      watchForUserScroll();
      document.dispatchEvent(new CustomEvent('scroll-restoration:done'));
    };
    if (savedPosition !== null) {
      window.scrollTo(0, parseInt(savedPosition, 10));
      requestAnimationFrame(finish);
    } else {
      finish();
    }
  }

  // Card content that resolves after the restore (e.g. per-product option
  // hints) grows rows above the viewport and pushes the target back down, so
  // the first return to a page lands high. Let that late content re-apply the
  // offset once it settles — but never after the user has taken over scrolling,
  // or we would yank the page out from under them.
  var userTookOver = false;
  function markUserTookOver() {
    userTookOver = true;
    window.removeEventListener('wheel', markUserTookOver);
    window.removeEventListener('touchstart', markUserTookOver);
    window.removeEventListener('keydown', markUserTookOver);
  }
  function watchForUserScroll() {
    window.addEventListener('wheel', markUserTookOver, { passive: true });
    window.addEventListener('touchstart', markUserTookOver, { passive: true });
    window.addEventListener('keydown', markUserTookOver);
  }

  window.__plpReapplyScroll = function () {
    if (userTookOver) return;
    var saved = sessionStorage.getItem(getScrollKey());
    if (saved !== null) {
      window.scrollTo(0, parseInt(saved, 10));
    }
  };

  // Async collection grids (e.g. Algolia) populate the DOM after this script
  // runs, so restoring immediately would clamp to a near-empty page. Wait for
  // their render-complete signal instead — but listen for it right away rather
  // than from DOMContentLoaded, because the grid script is deferred and often
  // finishes (straight from its cache) well before DOMContentLoaded fires on a
  // heavy page. Waiting for DOMContentLoaded to even start listening is what
  // keeps the page hidden long after the grid is actually ready.
  var restored = false;
  function restoreOnce() {
    if (restored) return;
    restored = true;
    restoreScrollPosition();
  }

  if (navType === 'back_forward' && savedPosition !== null) {
    if (isCollectionPage) {
      // Already rendered before this ran? Restore now — the event is long gone.
      if (window.__algoliaCollectionReady) {
        restoreOnce();
      } else {
        document.addEventListener('algolia:collectionReady', restoreOnce, { once: true });
        setTimeout(restoreOnce, RESTORE_TIMEOUT_MS);
      }
    } else {
      // Non-collection pages are server-rendered: restore as soon as the DOM
      // is parsed, exactly as before.
      document.addEventListener('DOMContentLoaded', restoreOnce);
    }
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      restoreScrollPosition();
    }
  });
})();
